import React from 'react';
import { useIntl } from 'react-intl';
import {
  DIRECTED_DIRECTOR_RUNS_PER_DAY,
  DIRECTED_DIRECTOR_RUNS_PER_VIDEO,
} from 'fym-shared/src/music24/directedVideoApi';
import { TypedMemo } from '../../../common/types';
import { directorMessages as messages } from '../../messages/directorMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the director steps; each part uses its own slice of it */
import styles from '../DirectorSteps.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** "Director runs left · 28 of 30" with its meter (design DvSide). */
const DirectorRunsComponent: React.FC<{ left: number; withText?: boolean }> = ({ left, withText = true }) => {
  const intl = useIntl();
  const shown = Math.max(0, Math.min(DIRECTED_DIRECTOR_RUNS_PER_VIDEO, left));
  return (
    <div className={styles.summary}>
      <div className={styles.runs}>
        <span>{intl.formatMessage(messages.runsLeft)}</span>
        <b>{intl.formatMessage(messages.runsCount, { left: shown, total: DIRECTED_DIRECTOR_RUNS_PER_VIDEO })}</b>
      </div>
      <div className={styles.meter}>
        <span style={{ width: `${(shown / DIRECTED_DIRECTOR_RUNS_PER_VIDEO) * 100}%` }} />
      </div>
      {withText && (
        <p className={styles.summaryText}>
          {intl.formatMessage(messages.runsText, {
            perVideo: DIRECTED_DIRECTOR_RUNS_PER_VIDEO,
            perDay: DIRECTED_DIRECTOR_RUNS_PER_DAY,
          })}
        </p>
      )}
    </div>
  );
};

export const DirectorRuns = TypedMemo(DirectorRunsComponent);
